import { getAuthedDataClient } from '@/lib/amplify-client';

export interface WishlistItem {
  id: string;
  ownerUserId: string;
  productId: string;
}

export async function listWishlistItems(userId: string): Promise<WishlistItem[]> {
  const client = await getAuthedDataClient();
  const { data } = await client.models.WishlistItem.list({
    filter: { ownerUserId: { eq: userId } },
  });
  return (data ?? []) as WishlistItem[];
}

export async function addWishlistItem(userId: string, productId: string): Promise<WishlistItem | null> {
  const client = await getAuthedDataClient();
  const { data } = await client.models.WishlistItem.create({
    ownerUserId: userId,
    productId,
  });
  return data as WishlistItem | null;
}

export async function removeWishlistItem(itemId: string): Promise<void> {
  const client = await getAuthedDataClient();
  await client.models.WishlistItem.delete({ id: itemId });
}

export async function removeWishlistItemByProduct(userId: string, productId: string): Promise<void> {
  const client = await getAuthedDataClient();
  const { data } = await client.models.WishlistItem.list({
    filter: { ownerUserId: { eq: userId }, productId: { eq: productId } },
  });
  await Promise.all((data ?? []).map((item: { id: string }) => client.models.WishlistItem.delete({ id: item.id })));
}
